import { MarketDtoBase } from '@prediction-market/common';

import { SIZE_DECIMALS } from '@/constants/solana';
import { Orderbook } from '@/types/contract';

export const clampInt = (n: number) => Math.max(1, Math.min(99, Math.trunc(n)));
export const bumpBuy = (p: number) => clampInt(clampInt(p) + 1);

export const roundSharesAmount = (
  shares: number,
  price: number,
  minSize: number,
) => {
  const roundingThreshold = minSize + 0.02; // If order less than min size + 0.02$
  const totalUsdc = shares * price;

  if (totalUsdc < roundingThreshold) {
    return Math.ceil(shares * 100) / 100;
  }

  return Math.floor(shares * 100) / 100;
};

export const deriveBestBidPriceFromOrderbook = (orderbook: Orderbook) => {
  const bestPrice = orderbook.bids[0].price;
  if (bestPrice) return bestPrice;
  return null;
};

export const deriveBestAskPriceFromOrderbook = (orderbook: Orderbook) => {
  const bestPrice = orderbook.asks[orderbook.asks.length - 1].price;
  if (bestPrice) return bestPrice;
  return null;
};

export const calculateTotalOrderbookUsdSize = (orderbook: Orderbook) => {
  return orderbook.bids.reduce(
    (acc, bid) => acc + (bid.size * bid.price) / SIZE_DECIMALS,
    0,
  );
};

export const getDefaultCoefficients = (market?: MarketDtoBase) => {
  const dbYesRaw = market?.defaultCoefficient?.[0] ?? 50;
  const dbNoRaw = market?.defaultCoefficient?.[1] ?? 50;
  const dbYes = Number(dbYesRaw);
  const dbNo = Number(dbNoRaw);
  return { defaultYes: dbYes, defaultNo: dbNo };
};
